import React, { useContext, useEffect, useRef, useState } from 'react'
import Application from '../../../StateContext/Application'
import { Cancel32, DeleteRed32, DeleteWhite32, EditBlueBlue32, EditWhite32, submit, Tax32 } from '../../../../../public/LoginImages/importimages';
import "./taaces.css";


function Taxes() {
  const statecalls = useContext(Application);
  const { TaxData, DeductionOperation } = statecalls;
 const [searchTerm, setSearchTerm] = useState("");//12-10 for search

  const [fetchDeductionData, setFetchDeductionData] = useState([]);

  const [data, setData] = useState({
    DeductionName: "",
  });

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 5; // Show 5 records per page

 // 12-10 for searcg
  const filteredDeductionData = fetchDeductionData.filter((item) =>
    [item.DeductionID, item.Deduction_Name].some((value) =>
      String(value ?? "")
        .toLowerCase()
        .includes(searchTerm.trim().toLowerCase())
    )
  );
  const totalPages = Math.ceil(
    filteredDeductionData.length / recordsPerPage
  );
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentDeductionData = filteredDeductionData.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  const handleChangeData = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let res = await DeductionOperation(data, "CreateDeductionDatainMaster");
      alert(res);
      setData({ ...data, DeductionName: "" });
      FetchInitalData();
    } catch (err) {
      console.log(err);
    }
  };

  const FetchInitalData = async () => {
    try {
      let res = await DeductionOperation(
        "null",
        "fetchalldatafromdeductiontable",
      );

      console.log("result :: ", res);

      setFetchDeductionData(res);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    FetchInitalData();
  }, []);
  const getPageNumbers = (currentPage, totalPages) => {
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    // Starting pages
    // 1 2 3 4 5 ... Last
    if (currentPage <= 3) {
      return [1, 2, 3, 4, 5, "...", totalPages];
    }

    // Last pages
    // ... 16 17 18 19 20
    if (currentPage >= totalPages - 2) {
      return [
        "...",
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }

    // Middle pages
    // ... 4 5 6 7 8 ... 20
    return [
      "...",
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
      "...",
      totalPages,
    ];
  };

  useEffect (()=>{
    setCurrentPage(1);
  },[searchTerm]);
//3/11
  const stickyTh = {
    padding: "10px",
    position: "sticky",
    top: 0,
    zIndex: 2,
    backgroundColor: "#2D79DB", 
  };

  return (

    //3/11
    
      <div
      style={{
        width: "93%",
        background: "#eef1f6",
        borderRadius: "12px",
        padding: "30px",
        boxSizing: "border-box",
        boxShadow: "0 3px 10px rgba(0, 0, 0, 0.10)",
        border: "1px solid #E1E6EF",
        marginTop:"15px",
        marginLeft:"40px",
        maxHeight:"89vh",
         transition: "margin-left 0.3s ease",
        overflowY: "auto",
        msOverflowStyle: "none", // IE & Edge
        scrollbarWidth: "none",

      }}
    >
      {/* //3/11 */}
      <style>{`.sticky-table-wrap thead th {
  position: sticky !important;
  top: 0 !important;
  z-index: 5 !important;
  background-color: #2D79DB !important;
  color: white;
}`
}</style>
      <h5
        style={{
          marginBottom: "10px",
          fontWeight: "700",
          color: "black",
          textAlign: "left",
          width: "100%",
        }}
      >
        <img
          src={"/Object-Code-32.png"}
          alt="Project Icon"
          style={{ marginRight: "10px", width: 28, height: 28 }}
        />
        Deduction Registration
      </h5>

      <div
        style={{
          width: "100%",
          backgroundColor: "#ffffff",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.10)",
          borderRadius: "10px",
          //3/11
          padding: "20px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "1200px",
            //30/10
            backgroundColor: "#EEF3F8",
            border: "1px solid #b5cfe9",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "10px",
            //3/11
            padding: "10px",
          }}
        >
          <form>
            <div
              style={{
                display: "grid",
                gap: "20px",
                width: "100%",
                gridTemplateColumns: "2fr 0fr", // exactly 2 columns

                // height: "100px"
              }}
            >
              <div
                style={{
                  display: "flex", // horizontal alignment
                  alignItems: "center", // vertically center label & input
                  marginLeft: "80px",
                }}
              >
                <label
                  className="form-label"
                  style={{
                    fontWeight: "700",
                    marginRight: "10px", // space between label and input
                    minWidth: "110px", // fix label width for alignment
                  }}
                >
                  Deduction Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Deduction Name"
                  value={data.DeductionName}
                  name="DeductionName"
                  onChange={(e) => handleChangeData(e)}
                  style={{
                    flex: 1, // input takes remaining width
                    border: "1px solid #ccc",
                    borderRadius: "10px",
                    padding: "10px",
                  }}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  marginTop: "20px",
                  justifyContent: "center",
                }}
              >

                <button
                  onClick={handleSubmit}
                  type="submit"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "20px",
                    width: "120px",
                    height: "40px",
                    backgroundColor: "#39b54a",
                    border: "none",
                    fontSize: "16px",
                    color: "#ffffff",
                    fontWeight: "700",
                  }}
                >  <img
                    src={submit}
                    style={{  marginRight: "10px", width: "1.2rem",  paddingBottom: "3px",   fontSize: "15px",  }}   />
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {fetchDeductionData.length > 0 && (
       //3/11
         <div style={{
          width: "100%",
          backgroundColor: "#ffffff",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.10)",
          borderRadius: "10px",
          //3/11
          padding: "20px",
          boxSizing: "border-box",
          marginTop:"20px"
        }}
      
    >
     {/* //3/11 */}
      <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    marginTop:"15px",
    marginBottom:"15px"


  }}
>
            <h5 style={{  fontWeight: "700", color: "black", textAlign: "left" }}>
              <img src={"/List-32.png"} alt="Project Icon" style={{ marginRight: "10px", width: 28, height: 28 }} /> Deduction List
            </h5>
 
            <div className="search-container">
              <img src={"/Search-32.png"} alt="Search Icon" className="search-icon" />
              <input type="text" className="search-input" placeholder="Search Project..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
            </div>
          </div>
 
        <div className="deduction-scroll">
          {/* <h5
            style={{
              marginBottom: "20px",
              fontWeight: "700",
              color: "black",
              textAlign: "left",
              width: "100%",
            }}
          >
            <img
              src={"/List-32.png"}
              alt="Project Icon"
              style={{ marginRight: "10px", width: 28, height: 28 }}
            />
            Deduction List
          </h5>
           */}
           {/* 12-10 for search */}
            {/* //30/10 */}
          <table
           style={{ width: "100%", borderCollapse: "separate",  borderSpacing: 0, borderRadius:"20px" }}
          >
            <thead>
              {/* //28/10 */}
              <tr
                style={{
                  backgroundColor: "#2D79DB",
                  color: "white",
                  height: "50px",
                  fontSize:"14px",
                  fontWeight:"400px",
                  textAlign: "center",
                }}
              >
                <th style={{ padding: "10px" }}>Sr.No</th>
                <th style={{ padding: "10px" }}>Deduction ID</th>
                <th style={{ padding: "10px" }}>Deduction Name</th>
              </tr>
            </thead>
            <tbody>
              {/* {currentDeductionData.map((val, index) => ( */}
              {/* 12-10 for no data msg */}
              {currentDeductionData.length > 0 ? (
                currentDeductionData.map((val, index) => (
 
                <tr
                  key={index}
                  //28/10
                  style={{
                    backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#CDE4F2",
                    height: "50px",
                  }}
                >
                  {/* //3/11 */}
                  <td style={{ padding: "10px", fontWeight: "500",fontSize:"13px", border: "1px solid white", }}>
                    {indexOfFirstRecord + index + 1}
                  </td>
                   {/* //3/11 */}
                  <td style={{ padding: "10px", fontWeight: "500",fontSize:"13px", color: "blue",textAlign:"center", border: "1px solid white", }}>
                    {val.DeductionID}
                  </td>
                   {/* //3/11 */}
                  <td style={{ padding: "10px", fontWeight: "500",fontSize:"13px", border: "1px solid white", }}>
                    {val.Deduction_Name}
                  </td>
              
                {/* </tr>
              ))} */}
              {/* 12-10 for no data msg */}
               </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      fontWeight: "600",
                      color: "#666",
                    }}
                  >
                    No data available
                  </td>
                </tr>
              )}
 
            </tbody>
          </table>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <p style={{ fontSize: "12px", color: "black" }}>
              Showing{" "} {filteredDeductionData.length===0 ? 0 : indexOfFirstRecord + 1}{" "} to {" "}
              {/* {Math.min(indexOfFirstRecord + 1, fetchDeductionData.length)} to{" "} */}
              {Math.min(indexOfLastRecord, filteredDeductionData.length)} of{" "}
              {filteredDeductionData.length} entries
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "18px",
              }}
            >
              {/* Previous */}
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                style={{
                  border: "none",
                  background: "transparent",
                  color: currentPage === 1 ? "#999" : "#2ea4e7",
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  fontSize: "13px",
                  padding: 0,
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  opacity: currentPage === 1 ? 0.5 : 1,
                }}
              >
                <span style={{ fontSize: "20px" }}>‹</span>
                Previous
              </button>

              {/* Page Numbers */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                {getPageNumbers(currentPage, totalPages).map(
                  (pageNumber, index) => {
                    // Dots
                    if (pageNumber === "...") {
                      return (
                        <span
                          key={`ellipsis-${index}`}
                          style={{
                            fontSize: "13px",
                            color: "#444",
                          }}
                        >
                          ...
                        </span>
                      );
                    }

                    // Page Number
                    return (
                      <button
                        key={pageNumber}
                        onClick={() => setCurrentPage(pageNumber)}
                        style={{
                          border: "none",
                          background: "transparent",
                          padding: 0,
                          color:
                            currentPage === pageNumber ? "#2ea4e7" : "#444",
                          cursor: "pointer",
                          fontSize: "13px",
                          fontWeight:
                            currentPage === pageNumber ? "600" : "400",
                          textDecoration:
                            currentPage === pageNumber ? "underline" : "none",
                        }}
                      >
                        {pageNumber}
                      </button>
                    );
                  },
                )}
              </div>

              {/* Next */}
              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages || totalPages === 0}
                style={{
                  border: "none",
                  background: "transparent",
                  color:
                    currentPage === totalPages || totalPages === 0
                      ? "#999"
                      : "#2ea4e7",
                  cursor:
                    currentPage === totalPages || totalPages === 0
                      ? "not-allowed"
                      : "pointer",
                  fontSize: "13px",
                  padding: 0,
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  opacity:
                    currentPage === totalPages || totalPages === 0 ? 0.5 : 1,
                }}
              >
                Next
                <span style={{ fontSize: "20px" }}>›</span>
              </button>
            </div>
          </div>
        </div>
        </div>
      )}
    </div>
  );
}

export default Taxes;